import * as React from 'react'
import { Tab, Tabs } from '@mui/material'
import { useState } from 'react'
import PersonIcon from '@mui/icons-material/Person'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import EmailIcon from '@mui/icons-material/Email'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { LrTrackCard } from './lrTrackCard'
import LineInput from '../common/lineinput'
import { useAtom } from 'jotai'
import { fetchLrStatusAtom, lrStatusAtom } from '../common/jotaiState/lrStatusStateAtoms'
import { ImagePreiewPopup } from '../common/snippets'

const LRdetails = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  let loginData = {}
  loginData.intCompanyID = searchParams.get('intCompanyID') || 0
  loginData.intBranchID = searchParams.get('intBranchID') || 0
  loginData.intUserID = searchParams.get('intUserID') || searchParams.get('U') || 0
  const tabNumber = searchParams.get('tab') || 0
  const csTab = searchParams.get('cstab') || 0
  const lrNumber = searchParams.get('lrNumber') || 0
  const BookingID = searchParams.get('BookingID') || searchParams.get('B') || 0
  const [, getLrStatus] = useAtom(fetchLrStatusAtom)
  const [lrStatus] = useAtom(lrStatusAtom)

  const [lrTabValue, setLrTabValue] = useState(parseInt(tabNumber))
  const [personImagePreview, setPersonImagePreview] = useState(false)
  const [personImageProps, setPersonImageProps] = useState(false)

  const [pcTabValue, setPcTabValue] = useState(parseInt(csTab))
  const LrDetails = lrStatus?.Data?.Table[0];

  const LrTrackData = lrStatus?.Data?.Table1;
  const firstStatus = LrTrackData ? LrTrackData?.[0] : false
  const lastStatus = LrTrackData ? LrTrackData[LrTrackData.length - 1] : false
  const showsenImage = firstStatus?.SenderImageURL || false
  const showsenIDImage = firstStatus?.IDProofImageURL || false
  const showRecImage = lastStatus?.SenderImageURL || false
  const showRecIDImage = lastStatus?.IDProofImageURL || false
  const consignmentDetails=lrStatus?.Data?.Table;
  let ShowLR =0;
  let consignmentType,mopName,description,totalUnits,unitSum,goodsValue,actualWeight,chargedWeight,allRate,allFreights,totalFreight;
  consignmentType=mopName=description=totalUnits=goodsValue=actualWeight=chargedWeight=allRate=allFreights='';
  unitSum=0;
  totalFreight=0;
  const Multi = consignmentDetails?.length>1
  consignmentDetails?.map((el,index,{ length })=>{
    unitSum+=parseInt(el.Quantity);
    totalFreight+=parseInt(el.Freight);
    if(index + 1 === length){
      consignmentType+=el.SubType;
      mopName+=el.MOPName;
      description+=el.Description;
      totalUnits+=el.Quantity;
      goodsValue+=el.GoodsValue;
      actualWeight+=el.ActualWeight+'KG'
      chargedWeight+=el.ChargedWeight+'KG'
      allRate+=el.Rate+' Per KG';
      allFreights+=el.Freight;
      ShowLR = el.LRNO
    }
    else{
      consignmentType+=el.SubType+',';
      mopName+=el.MOPName+',';
      description+=el.Description+',';
      totalUnits+=el.Quantity+'+';
      goodsValue+=el.GoodsValue+',';
      actualWeight+=el.ActualWeight+'KG'+',';
      chargedWeight+=el.ChargedWeight+'KG'+',';
      allRate+=el.Rate+' Per KG'+',';
      allFreights+=el.Freight+',';
    }
  });
  const mainTabIds = (index) => {
    return {
      id: `main-tab-${index}`,
      'aria-controls': `main-tabpanel-${index}`,
    }
  }
  const pcTabIds = (index) => {
    return {
      id: `pc-tab-${index}`,
      'aria-controls': `pc-tabpanel-${index}`,
    }
  }
  useEffect(() => {
    if (BookingID === 0) {
      const data = {
        ...loginData,
        strLRNO: lrNumber,
      }
      getLrStatus(data)
    }
    else {
      const data = {
        ...loginData,
        BookingID: BookingID,
        //strLRNO: Lrnumber,
      }
      getLrStatus(data)
    }
  }, [])
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab, pcTab) => {
    params.tab = lrTab
    params.cstab = pcTab
    setSearchParams(params)
  }
  const showImagePreviewPopup = (src) => {
    let data = {
      updateModal: setPersonImagePreview,
      data: { hideControl: true },
    }
    data.data.src = src
    setPersonImageProps(data)
    setPersonImagePreview(true)
  }
  return (
    <>
      {lrStatus ? (
        <div className="bg-dull">
          <div className="tablayout-main">
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={lrTabValue}
              onChange={(e, newValue) => {
                goToTabs(newValue, pcTabValue)
                setLrTabValue(parseInt(newValue))
              }}
              aria-label="bsic tabs example"
            >
              <Tab label="LR DETAILS" sx={{ width: '50%' }} aria-label="basic tabs example" {...mainTabIds(0)} />
              <Tab label="LR TRACKING" sx={{ width: '50%' }} aria-label="basic tabs example" {...mainTabIds(1)} />
            </Tabs>
          </div>
          <div className="lrContainer">
            <div className={'input--wrapper'}>
              <LineInput
                id={'lrNumber'}
                label={'LR Number'}
                type="text"
                name="ccr_lp"
                value={ShowLR}
                disabled={true}
                onChange={(e) => {}}
                sx={{ margin: '8px', width: '100%' }}
              />
            </div>
          </div>
          <div
            role="tabpanel"
            hidden={lrTabValue !== 0}
            id={`main-tabpanel-0`}
            aria-labelledby={`main-tab-0`}
            className="tab-main-1 detailed-tabs"
          >
            <div className="tablayout tab-secondary">
              <Tabs
                sx={{ borderBottom: 1, borderColor: 'divider' }}
                value={pcTabValue}
                onChange={(e, newValue) => {
                  goToTabs(lrTabValue, newValue)
                  setPcTabValue(parseInt(newValue))
                }}
                aria-label="basic tabs example"
              >
                <Tab label="PAYEE DETAILS" sx={{ width: '50%' }} aria-label="basic tabs example" {...pcTabIds(0)} />
                <Tab label="CONSIGNMENT DETAILS" sx={{ width: '50%' }} aria-label="basic tabs example" {...pcTabIds(1)} />
              </Tabs>
            </div>
            <div
              role="tabpanel"
              hidden={pcTabValue !== 0}
              id={`pc-tabpanel-0`}
              aria-labelledby={`pc-tab-0`}
              className="tab-pc-1 detailed-tabs tab1-view"
            >
              <div className="source-details">
                <div className="heading-tab">Source: {LrDetails?.FromCity}</div>
                <div className="tab-details">Branch: {LrDetails?.BkgBranchName}</div>
                <div className="tab-details">
                  <PersonIcon />
                  Sender Name:{LrDetails?.Sender}
                </div>
                <div className="tab-details">
                  <LocalPhoneIcon />
                  Sender No:{LrDetails?.SenderMobileNo}
                </div>
                {LrDetails?.SenderEmailID != '' && (
                  <div className="tab-details">
                    <EmailIcon />
                    Sender Email: {LrDetails?.SenderEmailID}
                  </div>
                )}

                {LrDetails?.SenderGSTN != '' && (
                  <div className="tab-details">
                    <CurrencyRupeeIcon />
                    Sender GSTN:{LrDetails?.SenderGSTN}
                  </div>
                )}
                {showsenImage && (
                  <div sx={{ width: '100%' }}>
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        maxWidth: '800px',
                        fontSize: '13px',
                        color: 'black',
                        margin: '0px',
                      }}
                    >
                      <span>Sender Image:</span>
                      <img
                        src={firstStatus.SenderImageURL}
                        width="100px"
                        height="66px"
                        style={{
                          height: '50px',
                          width: '50px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                          margin: '0px 10px',
                        }}
                        border="0"
                      />

                      <a
                        href=""
                        id="idImageViewLink"
                        // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                        className="thumbnail blue-color-txt"
                        onClick={(e) => {
                          e.preventDefault()
                          showImagePreviewPopup(firstStatus.SenderImageURL)
                        }}
                      >
                        Show
                       
                      </a>
                    </p>
                  </div>
                )}
                {showsenIDImage && (
                  <div sx={{ width: '100%' }}>
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        maxWidth: '800px',
                        fontSize: '13px',
                        color: 'black',
                        margin: '0px',
                      }}
                    >
                      <span>Sender ID Image:</span>
                      <img
                        src={firstStatus.IDProofImageURL}
                        width="100px"
                        height="66px"
                        style={{
                          height: '50px',
                          width: '50px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                          margin: '0px 10px',
                        }}
                        border="0"
                      />

                      <a
                        href=""
                        id="idImageViewLink"
                        // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                        className="thumbnail blue-color-txt"
                        onClick={(e) => {
                          e.preventDefault()
                          showImagePreviewPopup(firstStatus.IDProofImageURL)
                        }}
                      >
                        Show
                      
                      </a>
                    </p>
                  </div>
                )}
              </div>
              <div className="destination-details">
                <div className="heading-tab">Destination: {LrDetails?.ToCity}</div>
                <div className="tab-details">Branch: {LrDetails?.DestinationBranch}</div>
                <div className="tab-details">
                  <PersonIcon />
                  Receiver Name: {LrDetails?.RecName}
                </div>
                <div className="tab-details">
                  <LocalPhoneIcon /> Receiver No: {LrDetails?.RecMobileNo}
                </div>
                {LrDetails?.ReceiverEmailID != '' && (
                  <div className="tab-details">
                    <EmailIcon />
                    Receiver Email: {LrDetails?.ReceiverEmailID}
                  </div>
                )}
                {LrDetails?.ReceiverGSTN != '' && (
                  <div className="tab-details">
                    <CurrencyRupeeIcon />
                    Receiver GSTN:{LrDetails?.ReceiverGSTN}
                  </div>
                )}
                {lastStatus.TYPE === 'F' && showRecImage && (
                  <div sx={{ width: '100%' }}>
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        maxWidth: '800px',
                        fontSize: '13px',
                        color: 'black',
                        margin: '0px',
                      }}
                    >
                      <span>Receiver Image:</span>
                      <img
                        src={lastStatus.SenderImageURL}
                        width="100px"
                        height="66px"
                        style={{
                          height: '50px',
                          width: '50px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                          margin: '0px 10px',
                        }}
                        border="0"
                      />
                      <a
                        href=""
                        id="idImageViewLink"
                        // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                        className="thumbnail blue-color-txt"
                        onClick={(e) => {
                          e.preventDefault()
                          showImagePreviewPopup(lastStatus.SenderImageURL)
                        }}
                      >
                        Show
                      </a>
                    </p>
                  </div>
                )}
                {lastStatus.TYPE === 'F' && showRecIDImage && (
                  <div sx={{ width: '100%' }}>
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        maxWidth: '800px',
                        fontSize: '13px',
                        color: 'black',
                        margin: '0px',
                      }}
                    >
                      <span>Receiver ID Image:</span>
                      <img
                        src={lastStatus.IDProofImageURL}
                        width="100px"
                        height="66px"
                        style={{
                          height: '50px',
                          width: '50px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                          margin: '0px 10px',
                        }}
                        border="0"
                      />
                      <a
                        href=""
                        id="idImageViewLink"
                        // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                        className="thumbnail blue-color-txt"
                        onClick={(e) => {
                          e.preventDefault()
                          showImagePreviewPopup(lastStatus.IDProofImageURL)
                        }}
                      >
                        Show
                      </a>
                    </p>
                  </div>
                )}
              </div>
              <div className="bottom-container" style={{ display: 'none' }}>
                <div className="bottom-button-container">
                  <div className="outlined-bottom-button flex-center-all">Booking Cancel</div>
                  <div className="outlined-bottom-button flex-center-all">Delivery Cancel</div>
                  <div className="outlined-bottom-button flex-center-all">Booking Reprint</div>
                  <div className="outlined-bottom-button flex-center-all">Delivery Reprint</div>
                </div>
              </div>
            </div>
            <div
              role="tabpanel"
              hidden={pcTabValue !== 1}
              id={`pc-tabpanel-1`}
              aria-labelledby={`pc-tab-1`}
              className="tab-pc-2 detailed-tabs tab2-view"
            >
              <div className="tab2-container">
                <div className="cnsn-row misty-bg">
                  <div className="box-padding left">Consignment Type</div>
                  <div className="box-padding right">{consignmentType} </div>
                </div>
                <div className="cnsn-row misty-dark-bg">
                  <div className="box-padding left">Method of Packing</div>
                  <div className="box-padding right">mopName</div>
                </div>
                <div className="cnsn-row misty-bg">
                  <div className="box-padding left">Description</div>
                  <div className="box-padding right">{description}</div>
                </div>
                <div className="cnsn-row misty-dark-bg">
                  <div className="box-padding left">Total Units</div>
                  <div className="box-padding right">
                    {`${Multi ? totalUnits + '=' : ''}`}
                    {unitSum}
                  </div>
                </div>
                <div className="cnsn-row misty-bg">
                  <div className="box-padding left">Goods Value</div>
                  <div className="box-padding right">{goodsValue}</div>
                </div>
                <div className="cnsn-row misty-dark-bg">
                  <div className="box-padding left">Actual Weight</div>
                  <div className="box-padding right">{actualWeight}</div>
                </div>
                <div className="cnsn-row misty-dark-bg">
                  <div className="box-padding left">Charged Weight</div>
                  <div className="box-padding right">{chargedWeight}</div>
                </div>

                <div className="cnsn-row misty-bg">
                  <div className="box-padding left">Rate</div>
                  <div className="box-padding right">{allRate}</div>
                </div>
                <div className="cnsn-row">
                  <div className="box-padding left">Freight</div>
                  <div className="box-padding right">
                    {`${Multi ? allFreights + '=' : ''}`}
                    {totalFreight}
                  </div>
                </div>
                {LrDetails?.CartageAmount ? (
                  <div className="cnsn-row">
                    <div className="box-padding left">Collection Cartage</div>
                    <div className="box-padding right">{LrDetails?.CartageAmount}</div>
                  </div>
                ) : (
                  ''
                )}
                {LrDetails?.DeliveryCartage ? (
                  <div className="cnsn-row">
                    <div className="box-padding left">Delivery Cartage</div>
                    <div className="box-padding right">{LrDetails?.DeliveryCartage}</div>
                  </div>
                ) : (
                  ''
                )}
                {LrDetails?.OperatorHamali || LrDetails?.HamaliCharges ? (
                  <div className="cnsn-row">
                    <div className="box-padding left">Hamali and Operator Hamali</div>
                    <div className="box-padding right">
                      {LrDetails?.HamaliCharges}+{LrDetails?.OperatorHamali}=
                      {parseInt(LrDetails?.HamaliCharges) + parseInt(LrDetails?.OperatorHamali)}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {LrDetails?.Valuation ? (
                  <div className="cnsn-row">
                    <div className="box-padding left">Valuation Charge</div>
                    <div className="box-padding right">{LrDetails?.Valuation}</div>
                  </div>
                ) : (
                  ''
                )}
                {LrDetails?.OtherCharge ? (
                  <div className="cnsn-row">
                    <div className="box-padding left">Other Charges</div>
                    <div className="box-padding right">{LrDetails?.OtherCharge}</div>
                  </div>
                ) : (
                  ''
                )}
                {LrDetails?.ServiceTax ? (
                  <div className="cnsn-row">
                    <div className="box-padding left">GST</div>
                    <div className="box-padding right">{LrDetails?.ServiceTax}</div>
                  </div>
                ) : (
                  ''
                )}
                <div className="cnsn-row">
                  <div className="box-padding left">Total Amount</div>
                  <div className="box-padding right">{LrDetails?.NetAmount}</div>
                </div>
              </div>
              <div className="bottom-container" style={{ display: 'none' }}>
                <div className="search-button main-button flex-center-all">search new lr</div>
              </div>
            </div>
          </div>
          <div
            role="tabpanel"
            hidden={lrTabValue !== 1}
            id={`main-tabpanel-1`}
            aria-labelledby={`main-tab-1`}
            className="tab-main-2 details-container"
          >
            {LrTrackData?.map((Item, index) => {
              return <LrTrackCard data={Item} key={'lrTrackCard' + index} />
            })}
          </div>
        </div>
      ) : (
        ''
      )}
      {personImagePreview && <ImagePreiewPopup {...personImageProps} />}
    </>
  )
}
export default LRdetails
